import React from "react";

const Tabs = React.memo(function Tabs({ active, onChange }) {
  const items = ["summary", "checklist", "findings"];

  const labels = {
    summary: "Summary",
    checklist: "Checklist",
    findings: "Issues",
  };

  return (
    <div className="flex gap-2 border-b pb-2">
      {items.map((t) => (
        <button
          key={t}
          type="button"
          onClick={() => onChange(t)}
          className={[
            "px-3 py-1.5 rounded-md text-sm border",
            active === t
              ? "bg-gray-900 text-white border-gray-900"
              : "bg-white text-gray-700 border-gray-200 hover:bg-gray-50",
          ].join(" ")}
        >
          {labels[t] || t[0].toUpperCase() + t.slice(1)}
        </button>
      ))}
    </div>
  );
});

export default Tabs;
